// @core/api/endpoints/billing/list_balance_transactions.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListBalanceTransactionsResponse,
} from '../../../types/billing';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/billing';

/**
 * List balance transactions
 * Returns the history of balance changes for a billing account including charges, payments, credits, and adjustments.
 */
export async function ListBalanceTransactions(
  billingAccountId: string,
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListBalanceTransactionsResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/billing-accounts/:billingAccountId/balance-transactions`;
  requestPath = requestPath.replace(':billingAccountId', encodeURIComponent(billingAccountId));
  const requestOptions = options;
  return client.get<ListBalanceTransactionsResponse>(requestPath, { ...requestOptions, params });
}
